class FlixTabs extends HTMLElement {
  connectedCallback() {
    this._buttons = Array.from(this.querySelectorAll('[data-flix-tab-btn]'));
    this._panels = Array.from(this.querySelectorAll('[data-flix-tab-panel]'));
    this._buttons.forEach((btn) => btn.addEventListener('click', () => this.activate(btn.dataset.tab)));

    // Panels ship with an inline display (grid/block) for their visible state, which
    // outranks the browser's default [hidden]{display:none} rule. Normalize via
    // direct style.display toggling instead of relying on the hidden attribute alone.
    const initial = this._panels.find((p) => !p.hasAttribute('hidden')) || this._panels[0];
    if (initial) this.activate(initial.dataset.tab);
  }

  activate(tab) {
    this._buttons.forEach((btn) => {
      const active = btn.dataset.tab === tab;
      btn.style.background = active ? 'var(--accent)' : 'transparent';
      btn.style.color = active ? '#160d05' : 'var(--text)';
      // Sections like "Individual products" re-skin their whole accent
      // palette per active tab (matching the category sliders' per-category
      // colors). Buttons without data-accent-vars (e.g. Alerts tabs) just
      // don't opt into this.
      if (active && btn.dataset.accentVars) {
        const [accent, accent2, glow, border, borderHi] = btn.dataset.accentVars.split('|');
        this.style.setProperty('--accent', accent);
        this.style.setProperty('--accent2', accent2);
        this.style.setProperty('--glow', glow);
        this.style.setProperty('--border', border);
        this.style.setProperty('--borderHi', borderHi);
      }
    });
    this._panels.forEach((panel) => {
      // Capture each panel's original inline display (e.g. "grid") exactly
      // once, on whichever activate() call sees it first — before it's ever
      // touched. Capturing only in the "hide" branch (as before) loses the
      // initially-active panel's real value forever, since it's blanked out
      // on this very first call without ever being recorded.
      if (panel.dataset.flixShowDisplay === undefined) {
        panel.dataset.flixShowDisplay = panel.style.display || 'block';
      }
      const show = panel.dataset.tab === tab;
      if (show) {
        panel.style.display = panel.dataset.flixShowDisplay;
        panel.removeAttribute('hidden');
      } else {
        panel.style.display = 'none';
        panel.setAttribute('hidden', '');
      }
    });
  }
}
customElements.define('flix-tabs', FlixTabs);
